import { IJsonQueryRegionalDistrict } from '../../../../api-models/common/json_query';
import { createGeoTagsManager } from '../../utils/createGeoTagsManager';

export const geoRegionalDistrictTagsManager = createGeoTagsManager<IJsonQueryRegionalDistrict>({
  jsonQueryKey: 'regional_district_id',
  labelGetter: ({ geoTags, geoValue }) => geoTags.regionalDistricts[geoValue.id] || 'Неизвестный район',
  id: 'geoRegionalDistrict',
});
